import React from "react";
import PolicyLayout from "../../../components/PolicyLayout";
import s from "../../../styles/PolicyLayout.module.css";

export default function NotesparkPrivacy() {
  return (
    <PolicyLayout
      title="privacy policy"
      appName="Note Spark: AI Note Taker"
      date="NOVEMBER 2025"
    >
      {/* Intro */}
      <p>
        This Privacy Policy describes how Note Spark: AI Note Taker (“we”,
        “our”, “us”, or “the Application”) collects, uses, stores, and
        protects information when you use our mobile application. By
        downloading or using the Application, you consent to the practices
        described in this Policy.
      </p>

      {/* 1. Information We Collect */}
      <div className={s.title}>1) Information We Collect</div>

      <p><strong>User-Provided Data.</strong></p>
      <ul>
        <li>Text notes, voice recordings, or any other content created within the Application.</li>
        <li>These inputs are processed to provide AI-powered transcription, summarization, or organization features.</li>
      </ul>

      <p><strong>Automatically Collected Data.</strong></p>
      <ul>
        <li>Device information (model, OS version, language settings).</li>
        <li>IP address, crash logs, performance metrics.</li>
        <li>Usage statistics (features used, session frequency, AI interactions).</li>
      </ul>

      <p><strong>Payment Information.</strong></p>
      <ul>
        <li>Subscription or one-time purchases are processed via Apple App Store or Google Play.</li>
        <li>We do not store or access your credit card details.</li>
      </ul>

      <p><strong>Third-Party Services.</strong> The Application may use:</p>
      <ul>
        <li>Firebase (analytics, crash reporting)</li>
        <li>Google Analytics (usage data)</li>
        <li>RevenueCat (subscription management)</li>
        <li>AI processing provider (for transcription & summarization)</li>
      </ul>

      <p>
        We do not require account registration and do not collect personal
        identifiers (such as name or email) unless explicitly provided for
        customer support.
      </p>

      {/* 2. Legal Basis for Processing (GDPR) */}
      <div className={s.title}>2) Legal Basis for Processing (GDPR)</div>
      <ul>
        <li><strong>Performance of a contract:</strong> To deliver note-taking and AI features.</li>
        <li><strong>Consent:</strong> When you provide optional data or allow analytics.</li>
        <li><strong>Legitimate interest:</strong> To improve services, maintain security, and prevent abuse.</li>
        <li><strong>Legal obligation:</strong> To comply with applicable law.</li>
      </ul>

      {/* 3. How We Use Information */}
      <div className={s.title}>3) How We Use Information</div>
      <ul>
        <li>To enable AI-powered note-taking and transcription.</li>
        <li>To improve Application accuracy and features.</li>
        <li>To provide customer support.</li>
        <li>To monitor performance and prevent fraud.</li>
        <li>To comply with regulatory obligations.</li>
      </ul>

      {/* 4. Data Storage and Retention */}
      <div className={s.title}>4) Data Storage and Retention</div>
      <p>Notes and audio recordings may be temporarily processed on servers to provide AI features.</p>
      <p>Unless explicitly saved by the user, we do not permanently store your content.</p>
      <p>Analytics and technical logs are retained only as long as necessary for service improvement.</p>

      {/* 5. Sharing and Disclosure */}
      <div className={s.title}>5) Sharing and Disclosure</div>
      <p>We do not sell or rent personal data. Data may be shared only:</p>
      <ul>
        <li>With trusted third-party providers (AI services, analytics, subscription management).</li>
        <li>To comply with legal requests or regulations.</li>
        <li>During corporate restructuring (e.g., merger, acquisition).</li>
      </ul>

      {/* 6. International Data Transfers */}
      <div className={s.title}>6) International Data Transfers</div>
      <p>
        Your data may be transferred internationally. We use safeguards such
        as Standard Contractual Clauses (SCCs) to maintain compliance with GDPR.
      </p>

      {/* 7. User Rights */}
      <div className={s.title}>7) User Rights</div>

      <p><strong>Under GDPR (EEA users):</strong></p>
      <ul>
        <li>Right to access, correct, or delete personal data.</li>
        <li>Right to restrict or object to processing.</li>
        <li>Right to withdraw consent.</li>
        <li>Right to data portability.</li>
        <li>Right to lodge a complaint with a Data Protection Authority.</li>
      </ul>

      <p><strong>Under CCPA (California users):</strong></p>
      <ul>
        <li>Right to know what personal data is collected.</li>
        <li>Right to request deletion of data.</li>
        <li>Right to opt out of the sale of personal data (we do not sell).</li>
        <li>Right to non-discrimination for exercising privacy rights.</li>
      </ul>

      <p>Requests can be submitted via our contact email.</p>

      {/* 8. Children’s Privacy */}
      <div className={s.title}>8) Children’s Privacy</div>
      <p>
        The Application is not directed at children under 13 (or 16 in certain
        jurisdictions). We do not knowingly collect personal data from
        children.
      </p>

      {/* 9. Data Security */}
      <div className={s.title}>9) Data Security</div>
      <p>
        We employ industry-standard measures (encryption, secure transmission,
        restricted access) to protect your data. However, no system can
        guarantee absolute security.
      </p>

      {/* 10. Do Not Track */}
      <div className={s.title}>10) Do Not Track</div>
      <p>
        The Application does not currently respond to “Do Not Track” signals due
        to lack of an established industry standard.
      </p>

      {/* 11. Changes to This Privacy Policy */}
      <div className={s.title}>11) Changes to This Privacy Policy</div>
      <p>
        We may update this Privacy Policy to reflect changes in functionality,
        services, or legal requirements. Updates will be published within the
        Application or on official distribution platforms.
      </p>

      {/* 12. Contact Us */}
      <div className={s.title}>12) Contact Us</div>
      <p>Developer: Aleksandra Rakitina</p>
      <p>Email: alexwadek@gmail.com</p>
    </PolicyLayout>
  );
}
